import { Component,OnInit } from '@angular/core';
import { ExamService } from 'src/app/services/Exam/exam.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';

@Component({
  selector: 'app-tabulation-sheet',
  templateUrl: './tabulation-sheet.component.html',
  styleUrls: ['./tabulation-sheet.component.css']
})
export class TabulationSheetComponent implements OnInit {

  
  constructor(private reportservice: ExamService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) {

  }

  SearchModel = {
    StudentNo: '',
    ClassID: 0,
    SectionID:0,
    Print:'XLS',
     ClassSectionID: ""
  }

  ClearSearch() {
    this.SearchModel.StudentNo = '';
    this.SearchModel.ClassID = 0;
      
  }

  FilePath: any;    
  GetAcademicReport() {
        this.spinnerService.show();

        this.reportservice.GetAcademicReport(JSON.stringify(this.SearchModel)).subscribe((data) => {
            this.spinnerService.hide();
            this.FilePath = data.FilePath;            
         if(data.webResponse!=null)                    
            if(data.FilePath!=null)
            window.location = data.FilePath;
        });
    };
    ClassSectionList:any;
    GetClassSection  () {
       this.lookupservice.GetLookupsList('CTClassSection', '').subscribe( (data)=> {
            this.ClassSectionList = data.LookupItems;
   
       });
   
   };
   
    SetID  () {
        this.SearchModel.ClassID = 0;
        this.SearchModel.SectionID = 0;
        
       if ( this.SearchModel.ClassSectionID != "") {
           var strClassSectionID =  this.SearchModel.ClassSectionID.toString().split('-');
            this.SearchModel.ClassID = parseInt(strClassSectionID[0]);
            this.SearchModel.SectionID = parseInt(strClassSectionID[1]);
            
           
           
       }
   
   }
  
  ngOnInit() {
       this.GetClassSection();
   
   
  }

  
  
  
  TicketStatusList: any;
  BindTicketStatus() {
    this.lookupservice.GetLookupsList('TicketStatus', '').subscribe((data: any) => {
      this.TicketStatusList = data.LookupItems;

    });
  };

  
}